"use client"
import React, { useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';

const SubTitle = ({ text, textColor = "#fff", fontSize="1.5rem", lineHeight = "1.2", letterSpacing="-0.03em", fontWeight = "500", marGin = "0" }) => {

    const textRef = useRef(null);

    const textStyle = {
        fontWeight: fontWeight,
        fontSize:fontSize, // 64px (assuming 1rem = 20px)
        lineHeight: lineHeight, // 64px
        letterSpacing: letterSpacing, // -5%
        color: textColor,
        margin: marGin,
    };



    return (
        <p  style={textStyle} className={'subHeading fade-up'} ref={textRef}>
            {ReactHtmlParser(text)}
        </p>
    );
};

export default React.memo(SubTitle);
